import { useState as s, useEffect as n } from "react";
const f = (e) => {
  const [t, o] = s(""), [c, r] = s(e);
  return n(() => {
    const i = t === "" ? e : (e == null ? void 0 : e.filter(
      (l) => l.caption.toLowerCase().replace(/\s+/g, "").includes(t.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    r(() => i);
  }, [e, t]), { filteredData: c, setFilteredData: r, query: t, setQuery: o };
};
export {
  f as useFilteredData
};
